export default __webpack_public_path__ + "static/media/profile-picture-girl-1.57190dd7.jpeg";